import React from "react";

const toMetaList = (meta) => {
  if (meta == null || meta === false) return [];
  if (Array.isArray(meta)) return meta.filter(Boolean);
  return [meta];
};

/**
 * Item padrão do menu lateral de unidades/equipamentos.
 */
const SguUnitMenuItem = ({
  active = false,
  disabled = false,
  onClick,
  title,
  badge,
  topRight,
  meta,
  trailing,
  children,
  variant = "button",
  className = "",
  alert = false,
  warning = false,
  blocked = false,
  row = false,
}) => {
  const Tag = variant === "div" ? "div" : "button";
  const metaList = toMetaList(meta);
  const hasTrailing = Boolean(trailing);
  const useRow = row || hasTrailing;

  const classNames = [
    "sgu-unit-item",
    active ? "sgu-unit-item--active" : "",
    disabled ? "sgu-unit-item--disabled" : "",
    alert ? "sgu-unit-item--alert" : "",
    warning ? "sgu-unit-item--warning" : "",
    blocked ? "sgu-unit-item--blocked" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const body = (
    <div
      className={[
        "sgu-unit-item__body",
        useRow ? "sgu-unit-item__body--row" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className={useRow ? "sgu-unit-item__info" : undefined}>
        <div className="sgu-unit-item__top">
          <h5 className="sgu-unit-item__name">{title}</h5>
          {topRight != null && topRight !== false ? (
            topRight
          ) : badge != null && badge !== false ? (
            <span className="badge rounded-pill sgu-unit-item__badge">{badge}</span>
          ) : null}
        </div>
        {metaList.map((item, index) =>
          typeof item === "string" || typeof item === "number" ? (
            <p key={index} className="sgu-unit-item__meta">
              {item}
            </p>
          ) : (
            <React.Fragment key={index}>{item}</React.Fragment>
          )
        )}
        {children}
      </div>
      {hasTrailing ? (
        <div className="sgu-unit-item__trailing">{trailing}</div>
      ) : null}
    </div>
  );

  if (Tag === "div") {
    return (
      <div className={classNames} onClick={disabled ? undefined : onClick}>
        {body}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      disabled={disabled}
    >
      {body}
    </button>
  );
};

export default SguUnitMenuItem;
